/**
 * Qualitas D2C: years experience from DOB, assuming driving started at age 16.
 * Domain LicenseYears = experience years (age − 16).
 * RTR Licensed must be 16 (years from DOB → LicensedDt); see RtrApiService.
 */
import moment from "moment";

export const DRIVING_START_AGE = 16;

/** Whole years of age as of today (birthday-aware). */
export function ageFromBirthDate(birthDate: string | Date | null | undefined): number {
    if (!birthDate) return 0;
    const dob = moment(birthDate, ["MM/DD/YYYY", "M/D/YYYY", moment.ISO_8601], true);
    if (!dob.isValid()) {
        const fallback = moment(birthDate);
        if (!fallback.isValid()) return 0;
        return Math.max(0, moment().diff(fallback, "years"));
    }
    return Math.max(0, moment().diff(dob, "years"));
}

/** Years experience = max(0, age - 16). */
export function yearsExperienceFromBirthDate(birthDate: string | Date | null | undefined): number {
    return Math.max(0, ageFromBirthDate(birthDate) - DRIVING_START_AGE);
}

export function formatBirthDateForStore(value: Date | null | undefined): string {
    if (!value || !moment(value).isValid()) return "";
    return moment(value).format("MM/DD/YYYY");
}
